import ShoppingCart from "../../components/shoppingCart";

function CheckoutPage() {
  return (
    <div>
      <div className="cart-container">
        <ShoppingCart />
      </div>
    </div>
  );
}

export default CheckoutPage;
